export default (texto, isNumeroManual) => {
	if (texto) return texto
	if (isNumeroManual) return 'Não informado'
	return '---'
}
